export { AscWagesLayout } from './AscWagesLayout';
